// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__TNwiw","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__30smN"};